import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { PersistedUserCredentialsInterface } from '../../services/persisted-users.service.interface';
import '@diekeure/dcr-components/dcr-card.js';
import '@diekeure/dcr-components/dcr-inline-icon-button.js';
import '@diekeure/dcr-components/dcr-menu.js';
import '@diekeure/dcr-components/dcr-menu-item.js';
import '@diekeure/dcr-components/dcr-divider.js';
import '@diekeure/dcr-components/dcr-icon.js';

@Component({
  standalone: false,
  selector: 'kabas-persisted-user-card',

  templateUrl: './persisted-user-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersistedUserCardComponent {
  @HostBinding('class.kabas-persisted-user-card')
  hasPersistedUserCardClass = true;

  @Input() person: PersistedUserCredentialsInterface;
  @Input() isQuickLogin = false;
  @Input() isAddNew = false;
  @Input() isQRLogin = false;
  @Input() isLeerIDLogin = false;

  @Output() forgetAboutMe = new EventEmitter<PersistedUserCredentialsInterface>();

  @Output() quickLogin = new EventEmitter<PersistedUserCredentialsInterface>();
  @Output() addNew = new EventEmitter<void>();
  @Output() userCardClicked = new EventEmitter<void>();

  public prevent(e: Event) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
}
